import React, { useState } from 'react'

interface SelectItem {
  id: string
  name: string
}

interface SelectItemsProps {
  id: string
  items: SelectItem[]
  onChange?: React.ChangeEventHandler<HTMLSelectElement>
}

export const SelectItems: React.FC<SelectItemsProps> = ({ id, items, onChange }) => {
  const [value, setValue] = useState('')
  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setValue(e.target.value)
    if (onChange != null) {
      onChange(e)
    }
  }

  return (
    <select id={id} onChange={handleChange} value={value}>
      {items.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
    </select>
  )
}

export type { SelectItem }
